import { ServiceCodeBySystem, IntegrationSystem } from '@/shared/types';

import { config } from '@/config/index';

import { RouteConfig } from '@/router/types';

export const BIA_ROUTES: Record<keyof ServiceCodeBySystem<IntegrationSystem.BIA> | 'INSURANCE_ORDERS', RouteConfig> = {
  INSURANCE: { basePath: config.router.servicePath, path: 'insurance', isPrivate: true },
  INSURANCE_ORDERS: { basePath: config.router.userPath, path: 'insurance-orders', isPrivate: true },
};
